import { Component, OnInit, Input, ContentChild } from '@angular/core';

@Component({
    selector: 'mono-common-callout',
    templateUrl: './callout.component.html',
    styleUrls: ['./callout.component.scss']
})
export class CalloutComponent implements OnInit {
  @ContentChild('calloutButtons', { static: false }) calloutButtons: HTMLElement;

    @Input() base: string;
    @Input() type: string;
    @Input() animation: string;
    @Input() calloutText: string;
    @Input() errorDescription: string;
    @Input() success?: boolean;
    @Input() error?: boolean;
    @Input() positioning?: boolean;
    @Input() ariaLabel?: string;
    @Input() paddingOrMarginAlteration?: string;

    constructor() { }

    ngOnInit(): void {
    }

}